import './AddCustomDimension.scss';
import { KeyboardEvent, useState } from 'react';
import { Form } from 'react-bootstrap';
import { invalidDimensionMessage, isValidDimension } from '@src/utils/dimension-utils';
import { NO_AUTOFILL_PROPS } from '@src/utils/form-utils';
import { Button } from '../Button';
import { Appearance, Size } from '../designConstants';

interface AddCustomDimensionProps {
  existingValues: string[];
  onAdd: (value: string) => void;
}

// A dedicated control rather than Dropdown's `creatable`/`isValidNewOption`: this needs an
// inline format-error message on an invalid entry, not silent rejection.
export const AddCustomDimension = ({ existingValues, onAdd }: AddCustomDimensionProps) => {
  const [inputValue, setInputValue] = useState('');
  const [error, setError] = useState('');

  const submit = () => {
    const trimmed = inputValue.trim();
    if (!trimmed) return;
    if (!isValidDimension(trimmed)) {
      setError(invalidDimensionMessage(trimmed));
      return;
    }
    if (existingValues.includes(trimmed)) {
      setError(`"${trimmed}" is already in the list.`);
      return;
    }
    onAdd(trimmed);
    setInputValue('');
    setError('');
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      submit();
    }
  };

  return (
    <Form.Group className='add-custom-dimension'>
      <div className='add-custom-dimension-row'>
        <Form.Control
          {...NO_AUTOFILL_PROPS}
          placeholder='Add custom dimension (e.g. 320x100)'
          value={inputValue}
          isInvalid={Boolean(error)}
          onChange={e => {
            setInputValue(e.target.value);
            setError('');
          }}
          onKeyDown={handleKeyDown}
        />
        <Button
          appearance={Appearance.OUTLINED}
          size={Size.SM}
          disabled={inputValue.trim() === ''}
          onClick={submit}
        >
          Add
        </Button>
      </div>
      {error && <Form.Control.Feedback type='invalid'>{error}</Form.Control.Feedback>}
    </Form.Group>
  );
};
